import AuthMixin from '@/components/mixins/auth-mixin'
import Draggable from 'vuedraggable'
import CONST from '@/globals/constants'

export default {
  name: 'SelectedScheduleTagSlider',
  inject: [
    '$utils'
  ],
  components: {
    Draggable
  },
  props: {
    tagsProp: {
      default () { return [] }
    }
  },
  watch: {
    tagsProp: {
      handler (newVal) {
        this.tags = this.filterTags(newVal)
      },
      deep: true
    },
    tags: {
      handler () {
        this.$nextTick(_ => {
          this.setElementDataHeightAttributeValue()
        })
      },
      deep: true
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      elementHeight: 0,
      tags: [],

      selectedDropzoneId: null
    }
  },
  computed: {
    sortDraggableOptions () {
      return { animation: 250 }
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action) {
        this.$emit('selected-schedule-tags-slider-change', { action, payload: { data } })
      }
    },
    setDefaultData () {
      this.tags = this.filterTags(this.tagsProp)
    },
    setElementDataHeightAttributeValue () {
      this.elementHeight = $('#selectedScheduleTagsSlider').height()
    },
    filterTags (tags) {
      let newTags = this.$utils.clone(tags)

      // Add default ALL Tag
      newTags.push({
        value: '_toSeeAllData',
        label: this.$t('label.all'),
        color: '#fff'
      })

      newTags = this.$utils.filterTagOptionsForUI({ tags: newTags, showLabel: true })
      newTags = newTags.filter((tag) => { return !tag.value.includes(':') })

      return newTags
    },
    handleTagItemClick ($event, tag, indx) {
      if (tag.value !== '_toSeeAllData') {
        return
      }

      this.emitEvent('ALL_TAG_SELECTED', tag)
    },
    /**
     * Sets selectedDropzoneId and adds ui-droppable-hover class to element
     */
    setSelectedDropzoneId (dropzoneId) {
      if (!dropzoneId) {
        return
      }

      const dropzone = document.getElementById(dropzoneId)
      if (dropzone) {
        this.selectedDropzoneId = dropzoneId
        dropzone.classList.add('ui-droppable-hover')
      }
    },
    /**
     * Clears selectedDropzoneId and remove ui-droppable-hover class from element
     */
    removeSelectedDropzoneId () {
      if (!this.selectedDropzoneId) {
        return
      }

      const dropzone = document.getElementById(this.selectedDropzoneId)
      if (dropzone) {
        dropzone.classList.remove('ui-droppable-hover')
      }

      this.selectedDropzoneId = null
    },
    /**
     * Handle on drag move event for setting up selectedDropzoneId
     * from event.to
     */
    handleDraggableMove (event) {
      // Disabled dragging `All` tag
      if (
        event.dragged?.classList?.contains(CONST.ALL_TAG_VALUE) ||
        event.dragged?.className?.includes(CONST.ALL_TAG_VALUE) ||
        event.draggedContext?.element?.value === CONST.ALL_TAG_VALUE
      ) {
        return false
      }

      if (event.to.id === this.selectedDropzoneId) {
        return true
      }

      this.removeSelectedDropzoneId()
      this.setSelectedDropzoneId(event.to.id)

      return true
    },
    /**
     * Handle on drag move end event for restoring selectedDropzoneId
     */
    handleDraggableEnd () {
      this.removeSelectedDropzoneId()
    }
  },
  mounted () {
    this.setDefaultData()
  }
}
